interface JsonLdProps {
  data: Record<string, unknown>;
}

// Donnees JSON-LD injectees sont definies en dur dans le code source (pas de contenu utilisateur).
// dangerouslySetInnerHTML est securise ici car les donnees ne proviennent pas d'input externe.
export function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
